export enum CheckoutFlowVariants {
  Off = 'off',
  VariantA = 'variant-a',
  VariantB = 'variant-b',
}

export interface VariantProps {
  /**
   * Intializes the payment flow
   */
  onPaymentInit: () => void;
}
